export const groupCategories = categories => {
  const result = []

  for (const category of categories) {
    const higherCategories = categories.map(item => parseInt(item.categoriaSuperior))
    const higherCategoriesFiltered = higherCategories.filter((item, index) => higherCategories.indexOf(item) === index)

    const group = categories.find(
      item =>
        higherCategoriesFiltered.includes(parseInt(item.categoriaSuperior)) &&
        item.codigo === category.categoriaSuperior
    )

    if (group) {
      result.push({
        ...category,
        group: group.descricao
      })
    } else {
      result.push(category)
    }
  }

  return result.filter(item => item.group)
}
